(function ($) {
  $(document).ready(function () {

    if($('.section--boards-committees-list').length){

      let category = $('.boards-category-select__item.active').data('category');
      let tid = $('.title-wrapper.active').data('slide');

      $('.boards-category-select__item').on('click', function(){
        const newCategory = $(this).data('category');

        if(newCategory !== category){
          category = newCategory;
          tid = $('.title-list[data-category="'+ category +'"]').find('.title-wrapper').first().data('slide');
          console.log('TID', tid);
          updateDisplay(category, tid);
        }
      });

      $('.title-wrapper').on('click', function(){
        tid = $(this).data('slide');
        updateDisplay(category, tid);
      });

      function updateDisplay(category, tid){
        const button = $('.boards-category-select__item[data-category="'+ category +'"]');
        button.addClass('active');
        $('.boards-category-select__item').not(button).removeClass('active');

        const list = $('.title-list[data-category="'+ category +'"]');
        list.addClass('active');
        $('.title-list').not(list).removeClass('active');

        const title = $('.title-wrapper[data-slide="'+ tid +'"]');
        title.addClass('active');
        $('.title-wrapper').not(title).removeClass('active');

        const slide = $('.boards-committees-content-block[data-tid="'+ tid +'"]');
        slide.addClass('active');
        $('.boards-committees-content-block').not(slide).removeClass('active');

        // Mobile
        $('.m__types .m__type').removeClass('active');
        $('.m__types .m__type[data-category="'+ category +'"]').addClass('active');
      }

    }
  });
})(jQuery);
